import classNames from 'classnames';
import React      from 'react';

import BaseTabs from './base/base.tabs';

import * as PropTypes from 'prop-types';

export const RenderBasicTabs = (props) => <BaseTabs {...props} className={classNames('basic-tabs', props.className)} />;

RenderBasicTabs.propTypes = {
  nav:       PropTypes.array,
  title:     PropTypes.string,
  active:    PropTypes.number,
  className: PropTypes.string,
  size:      PropTypes.string,
  changeTab: PropTypes.func,
};